import axiosInstance from "../helpers/axiosInstance";
const role = localStorage.getItem("userRole");

export const addStaffApi = async (request) => {
  const url = `admin/staff`;
  const response = await axiosInstance.post(url, request);
  return response.data;
};

export const getStaffApi = async (pageNo, searchKey, sort = {}, filterData = {}) => {
  const params = {
    page: pageNo,
    searchKey: searchKey ?? undefined,
    sortField: sort.sortField ?? undefined,
    sortMethod: sort.sortType ?? undefined,
    status: filterData.status ?? undefined,
    role: filterData.role ?? undefined,
  };

  const url = `admin/staff`;
  const response = await axiosInstance.get(url, { params });
  return response.data;
};

export const getStaffProfileApi = async () => {
  const url = `staff/profile`;
  const response = await axiosInstance.get(url);
  return response.data;
};

export const getStaffByIdApi = async (staffId) => {
  const url = `admin/staff/${staffId}`;
  const response = await axiosInstance.get(url);
  return response.data;
};

export const updateStaffApi = async (request) => {
  const url = role === "staff"
    ? `staff/profile`
    : `admin/staff`;
  const response = await axiosInstance.put(url, request);
  return response.data;
};

export const updateStaffStatusApi = async (userId, status) => {
  const url = `admin/staff/${userId}/status/${status}`;
  const response = await axiosInstance.put(url);
  return response.data;
};

export const updatePasswordApi = async (request) => {
  const url = `staff/password`;
  const response = await axiosInstance.put(url, request);
  return response.data;
};
